import { Separator } from '@components/separator';
import { Stack, StackProps } from '@components/stack';
import { Text, TextProps } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

export const OrDivider = (props: Pick<TextProps, 'font' | 'color'> & Pick<StackProps, 'space'>) => {
  const { font = 'semibold14', color = 'textSecondary', space = 2 } = props;
  const { t } = useScopedTranslate();

  return (
    <Stack
      space={space}
      orientation="horizontal"
      justify="center"
      align="center"
      style={{ width: '100%' }}
    >
      <Separator />
      <Text font={font} color={color} caps text={t('core.or')} />
      <Separator />
    </Stack>
  );
};
